// ===== ENGINEERING & TECHNOLOGY =====
const ENGINEERING = [
  {
    id: "cse",
    name: "B.Tech in Computer Science & Engineering",
    stream: "science",
    category: "engineering",
    summary:
      "Core computing: algorithms, systems, networks, software & hardware integration.",
    eligibility:
      "10+2 with PCM; JEE Main & Advanced for IITs/NITs; State CETs for state colleges.",
    exams: [
      "JEE Main",
      "JEE Advanced",
      "MHT-CET",
      "KCET",
      "TNEA",
      "UPSEE",
      "WBJEE",
      "OJEE",
      "MET"
    ],
    colleges: [
      "IIT Bombay",
      "IIT Delhi",
      "IIT Kanpur",
      "IIT Kharagpur",
      "IIT Madras",
      "NIT Trichy",
      "NIT Surathkal",
      "IIIT Hyderabad",
      "VIT Vellore",
      "Anna University, Chennai",
      "RV College of Engineering, Bengaluru",
      "Manipal Institute of Technology"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["software", "hardware", "networks", "algorithms"],
  },
  {
    id: "ece",
    name: "B.Tech in Electronics & Communication Engineering",
    stream: "science",
    category: "engineering",
    summary:
      "Communication systems, semiconductors, embedded systems, devices & signal processing.",
    eligibility:
      "10+2 with PCM; JEE Main/Advanced for top institutes; State CETs for state colleges.",
    exams: [
      "JEE Main",
      "JEE Advanced",
      "MHT-CET",
      "KCET",
      "TNEA",
      "UPSEE",
      "WBJEE",
      "OJEE"
    ],
    colleges: [
      "IIT Bombay",
      "IIT Delhi",
      "IIT Kanpur",
      "IIT Kharagpur",
      "IIT Madras",
      "NIT Trichy",
      "NIT Surathkal",
      "RV College of Engineering, Bengaluru",
      "Anna University, Chennai",
      "VIT Vellore",
      "Manipal Institute of Technology"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["electronics", "communication", "embedded", "signals"],
  },
  {
    id: "eee",
    name: "B.Tech in Electrical & Electronics Engineering",
    stream: "science",
    category: "engineering",
    summary:
      "Power systems, control systems, robotics, industrial automation, and renewable energy.",
    eligibility:
      "10+2 with PCM; JEE Main/Advanced for top institutes; State CETs for state colleges.",
    exams: [
      "JEE Main",
      "JEE Advanced",
      "MHT-CET",
      "KCET",
      "TNEA",
      "UPSEE",
      "WBJEE",
      "OJEE"
    ],
    colleges: [
      "IIT Kharagpur",
      "IIT Kanpur",
      "IIT Madras",
      "NIT Trichy",
      "NIT Surathkal",
      "Anna University, Chennai",
      "RV College of Engineering, Bengaluru",
      "VIT Vellore"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["power", "control", "automation", "renewable"],
  },
  {
    id: "mech",
    name: "B.Tech in Mechanical Engineering",
    stream: "science",
    category: "engineering",
    summary:
      "Design, analysis, manufacturing, automotive, mechatronics, energy systems, and robotics.",
    eligibility:
      "10+2 with PCM; JEE Main/Advanced for top institutes; State CETs for state colleges.",
    exams: [
      "JEE Main",
      "JEE Advanced",
      "MHT-CET",
      "KCET",
      "TNEA",
      "UPSEE",
      "WBJEE",
      "OJEE"
    ],
    colleges: [
      "IIT Bombay",
      "IIT Delhi",
      "IIT Kanpur",
      "IIT Kharagpur",
      "IIT Madras",
      "NIT Trichy",
      "NIT Surathkal",
      "Anna University, Chennai",
      "RV College of Engineering, Bengaluru",
      "VIT Vellore",
      "Manipal Institute of Technology"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["machines", "manufacturing", "automobile", "energy", "mechatronics"],
  },
  {
    id: "civil",
    name: "B.Tech in Civil Engineering",
    stream: "science",
    category: "engineering",
    summary:
      "Infrastructure planning, construction, structural engineering, transportation, water resources & geotechnics.",
    eligibility:
      "10+2 with PCM; JEE Main/Advanced for top institutes; State CETs for state colleges.",
    exams: [
      "JEE Main",
      "JEE Advanced",
      "MHT-CET",
      "KCET",
      "TNEA",
      "UPSEE",
      "WBJEE",
      "OJEE"
    ],
    colleges: [
      "IIT Kharagpur",
      "IIT Roorkee",
      "IIT Kanpur",
      "NIT Trichy",
      "NIT Surathkal",
      "Anna University, Chennai",
      "RV College of Engineering, Bengaluru",
      "VIT Vellore"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["structures", "construction", "transportation", "geotech"],
  },
  {
    id: "aero",
    name: "B.Tech in Aerospace Engineering",
    stream: "science",
    category: "engineering",
    summary:
      "Design, development, testing of aircraft & spacecraft; aerodynamics & propulsion.",
    eligibility:
      "10+2 with PCM; JEE Main/Advanced for IITs; State CETs for state colleges.",
    exams: [
      "JEE Main",
      "JEE Advanced",
      "MHT-CET",
      "KCET",
      "TNEA",
      "UPSEE",
      "WBJEE",
      "OJEE"
    ],
    colleges: [
      "IIT Bombay",
      "IIT Kanpur",
      "IIT Madras",
      "IIT Kharagpur",
      "Anna University, Chennai",
      "RV College of Engineering, Bengaluru",
      "VIT Vellore"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["aircraft", "spacecraft", "propulsion", "aerodynamics"],
  },
  {
    id: "biomed",
    name: "B.Tech in Biomedical Engineering",
    stream: "science",
    category: "engineering",
    summary:
      "Application of engineering in healthcare: medical devices, diagnostics, prosthetics & instrumentation.",
    eligibility:
      "10+2 with PCB/PCM; JEE/State CETs for top B.Tech programs; NEET not mandatory.",
    exams: [
      "JEE Main",
      "JEE Advanced",
      "MHT-CET",
      "TNEA",
      "WBJEE",
      "OJEE"
    ],
    colleges: [
      "IIT Delhi",
      "IIT BHU Varanasi",
      "Anna University, Chennai",
      "Manipal Institute of Technology",
      "VIT Vellore"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["medical devices", "healthcare", "prosthetics", "diagnostics"],
  },
  {
    id: "chemical",
    name: "B.Tech in Chemical Engineering",
    stream: "science",
    category: "engineering",
    summary:
      "Process design and chemical production: pharma, polymers, energy, materials & petrochem.",
    eligibility:
      "10+2 with PCM; JEE/State CETs for top B.Tech programs.",
    exams: [
      "JEE Main",
      "JEE Advanced",
      "MHT-CET",
      "KCET",
      "TNEA",
      "UPSEE",
      "WBJEE",
      "OJEE"
    ],
    colleges: [
      "IIT Bombay",
      "IIT Delhi",
      "IIT Kanpur",
      "IIT Madras",
      "NIT Trichy",
      "Anna University, Chennai",
      "VIT Vellore"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["chemical", "process", "pharma", "polymers", "materials"],
  },
  {
    id: "marine",
    name: "B.Tech in Marine / Naval Architecture",
    stream: "science",
    category: "engineering",
    summary:
      "Ship design, construction, ocean engineering, marine operations & safety.",
    eligibility:
      "10+2 with PCM; JEE/State CETs for IITs/NITs; other maritime institutes have own tests.",
    exams: ["JEE Main", "JEE Advanced", "State CETs", "MERI Kolkata Entrance"],
    colleges: [
      "IIT Kharagpur",
      "IIT Madras",
      "Cochin University of Science & Technology",
      "MERI Kolkata"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["marine", "ships", "ocean", "naval architecture"],
  },
  {
    id: "cyber",
    name: "B.Tech in Cyber Security",
    stream: "science",
    category: "it-comps",
    summary:
      "Securing computer systems & networks: threat analysis, forensics, cryptography, law & ethics.",
    eligibility:
      "10+2 with PCM; JEE/State CETs for B.Tech CS/IT with specialization; CUET UG for colleges offering B.Sc IT/Cyber Security.",
    exams: [
      "JEE Main",
      "CUET UG",
      "State CETs"
    ],
    colleges: [
      "IIT Hyderabad",
      "IIIT Allahabad",
      "IIIT Guwahati",
      "Anna University, Chennai",
      "VIT Vellore",
      "Manipal Institute of Technology"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["security", "cryptography", "forensics", "networks"],
  },
];

export default ENGINEERING;
